module.exports = __webpack_public_path__ + "img/p-14-3.5cb58947.jpg";